import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import './index.less'
import { localDocumentContentPart } from '../../../types/localDoment-dto'
import { useGetLocalDocumentQuery } from '../../../core/localDocuments'
import { CustomModal } from '../../common/CustomModal'
import { SpinLoader } from '../../common/SpinLoader'

interface ModalLegalDocumentProps {
  handleClose: () => void
  display: boolean
  documentType: string
}

export const ModalLegalDocument: FC<ModalLegalDocumentProps> = ({ handleClose, display, documentType }) => {
  const { t } = useTranslation()
  const { data: legalDocumentText, isLoading } = useGetLocalDocumentQuery({ documentType })

  return (
    <CustomModal closable={false} isVisible={display} title={legalDocumentText?.title ?? 'Document'} handleClose={handleClose} secondaryBtnTitle={t('buttons.close')}>
      <div className="modalLegalDocument">
        {isLoading && <SpinLoader />}
        {legalDocumentText && (
          <div className="modalLegalDocument__innerWrap">
            <div className="modalLegalDocument__block">
              <h4 className="h-4 text-bold text-center mb-1">{legalDocumentText.title.toUpperCase()}</h4>
              <h5 className="h-5 text-bold text-center mb-3">{legalDocumentText.subtitle.toUpperCase()}</h5>
            </div>
            {legalDocumentText.content.map(({ title, parts }, index) => {
              return (
                <div key={index} className="modalLegalDocument__block">
                  {title && <h5>{title.toUpperCase()}</h5>}
                  {parts.map((tocp, partIndex) => {
                    switch (tocp.type) {
                      case 'paragraphs':
                        return (
                          <div key={partIndex} className="modalLegalDocument__block__description">
                            {(tocp as localDocumentContentPart<'paragraphs'>).content.map((text: string, index: number) => (
                              <p key={index}>{text}</p>
                            ))}
                          </div>
                        )
                      case 'list':
                        const { title, listItems } = (tocp as localDocumentContentPart<'list'>).content
                        return (
                          <div className="modalLegalDocument__block__list" key={partIndex}>
                            <p>{title}</p>
                            <ol>
                              {listItems.map((item: string, index: number) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ol>
                          </div>
                        )
                      case 'definitions':
                        const { title: definitionsTitle, definitionsItems } = (tocp as localDocumentContentPart<'definitions'>).content
                        return (
                          <div className="modalLegalDocument__block__description" key={partIndex}>
                            <p>{definitionsTitle}</p>
                            <div>
                              {definitionsItems.map(({ term, description }, index) => (
                                <p key={index}>
                                  <strong>{term}</strong> {description}
                                </p>
                              ))}
                            </div>
                          </div>
                        )
                      default:
                        return
                    }
                  })}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </CustomModal>
  )
}
